module.exports = __webpack_public_path__ + "static/media/Mommas_Pancake_Breakfast_780x390.f966fdc9.jpg";